import { render, staticRenderFns } from "./CRFCheckboxTable.vue?vue&type=template&id=ba696a6a&scoped=true&"
import script from "./CRFCheckboxTable.vue?vue&type=script&lang=js&"
export * from "./CRFCheckboxTable.vue?vue&type=script&lang=js&"
import style0 from "./CRFCheckboxTable.vue?vue&type=style&index=0&id=ba696a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba696a6a",
  null
  
)

export default component.exports